
























import { defineComponent } from "@vue/composition-api";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "ExportFooterButton",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    typeName: {
      type: String,
      default: "PDF",
    },
  },
  computed: {
    ...mapGetters("app", ["isExportFileLoading"]),
  },
});
